var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcArrowInCircleRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 40,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#83868A",
  clipPath: "url(#ic-arrow-in-circle-right_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 0C8.95 0 0 8.95 0 20s8.95 20 20 20 20-8.95 20-20S31.05 0 20 0m0 38.333C9.883 38.333 1.667 30.117 1.667 20S9.883 1.667 20 1.667 38.333 9.883 38.333 20 30.117 38.333 20 38.333"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.77 20.833h12.4l-4.616 4.617a.825.825 0 0 0 0 1.183.825.825 0 0 0 1.183 0l6.05-6.05s.134-.167.184-.267a.83.83 0 0 0 0-.633c-.05-.1-.1-.2-.184-.267l-6.05-6.05a.84.84 0 0 0-.583-.25.8.8 0 0 0-.583.25.825.825 0 0 0 0 1.184l4.616 4.616h-12.4a.825.825 0 0 0-.833.834c0 .466.367.833.833.833h-.016Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-arrow-in-circle-right_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v40H0z"
})))));
export default SvgIcArrowInCircleRight;